import { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom'

import { getChatNotifications } from '../../../api/notificationFetches'
import imgChat from '../../../assets/images/icon_chat_outline.svg'
import imgChatUnread from '../../../assets/images/icon_chat_unread.svg'
import { useUserContext } from '../../../contexts/userContext'

import { ChatNotifications } from './ChatNotifications/ChatNotifications'
import { Mail } from './styles'
import { IChatNotification } from './types'

export const NotificationHub = () => {
  const location = useLocation()
  const { state: userState } = useUserContext()
  const [menuOpen, setMenuOpen] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper chatNotifications type
  const [chatNotifications, setChatNotifications] = useState<any>([])
  const [hasUnread, setHasUnread] = useState<boolean>(false)

  const findUnreads = (notifications: IChatNotification[]) => {
    if (notifications?.length) {
      const unreads = notifications.filter(
        (item: IChatNotification) => item.has_unread,
      )
      setHasUnread(unreads.length > 0)
    }
  }

  const loadMore = (pageNumber: number) => {
    getChatNotifications(userState.public_id, pageNumber).then(data => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper prevState type
      setChatNotifications((prevState: any) => {
        return { ...data, data: prevState.data.concat(data.data) }
      })
    })
  }

  useEffect(() => {
    if (userState.public_id) {
      getChatNotifications(userState.public_id).then(data => {
        if (data) {
          setChatNotifications(data)
          findUnreads(data.data)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: userState.public_id intentionally omitted to prevent unnecessary re-fetches when location changes
  }, [location])

  return (
    <>
      <Mail
        src={hasUnread ? imgChatUnread : imgChat}
        onClick={() => setMenuOpen(!menuOpen)}
      />
      <ChatNotifications
        display={menuOpen}
        notifications={chatNotifications}
        menuToggle={setMenuOpen}
        loadMore={loadMore}
      />
      {/*<Ring />*/}
    </>
  )
}
